import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-6" }
const _hoisted_2 = { class: "card-body pt-5 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Cấu hình Vị trí tuyển dụng")
], -1)
const _hoisted_5 = { class: "me-0 mb-0 text-end" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_8 = { class: "card-body pt-10" }
const _hoisted_9 = { class: "tab-content" }
const _hoisted_10 = {
  class: "tab-pane fade active show",
  id: "tabs_edit_general",
  item: "tabpanel"
}
const _hoisted_11 = { class: "my-5 px-8" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-12 mb-5" }
const _hoisted_14 = { class: "d-flex justify-content-between mb-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-2 mb-5" }, "Cấu hình vị trí tuyển dụng", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "border border-gray-500 bg-light-dark py-3 mb-2 ps-2 fs-3 rounded item-menu" }
const _hoisted_20 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_21 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_22 = { class: "action" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "add_experience_form",
    model: _ctx.objectData,
    rules: _ctx.rules,
    ref: "formRef",
    class: "form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn-primary btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addPositionItem())),
                        class: "btn btn-sm btn-success btn-icon me-1"
                      }, _hoisted_17)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positionItems, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "col-md-8"
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                onBlur: ($event: any) => (item.key = _ctx.convertSlug(item.value)),
                                class: "form-control form-control-sm mb-1 fs-5 me-5"
                              }, null, 40, _hoisted_21), [
                                [_vModelText, item.value]
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.removePositionItem(index)),
                                  class: "btn btn-sm btn-danger btn-icon me-1"
                                }, _hoisted_25, 8, _hoisted_23)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}